import { RibbonType } from '../../components/ribbon/ribbon.component';

interface FeatureCard {
  icon?: string;
  title: string;
  content: string;
  action: {
    href: string;
    label: string;
  };
  image: string;
  ribbon?: RibbonType;
}

export const featureCards: FeatureCard[] = [
  {
    icon: 'icons/geo-bird.svg',
    title: $localize`Geo-Bird - Wayline management`,
    image: 'images/home_geo-bird.png',
    content: $localize`Create optimized waylines for your chosen fields and implements in just a few simple steps.`,
    action: {
      href: '/geo-bird',
      label: $localize`Go to Geo-Bird`,
    },
    ribbon: 'product',
  },
  /* TODO: Enable again when OSM Service has been fixed
  {
    title: $localize`Public landscape objects`,
    content:
      $localize`Find public information about objects in your fields, such as windmills, lakes, roads, etc. Download an ISOXML file with the objects and use it in your tractor terminal or farm management system.`,
    image: 'images/home_OSM.png',
    action: {
      href: '/public-landscape-objects',
      label: $localize`Go to Public landscape objects`,
    },
    ribbon: 'prototype',
  },
  */
  {
    title: $localize`Soil Compaction`,
    content: $localize`Minimize soil compaction by optimizing how you drive in the field, which machinery you use and how you configure your tires.`,
    image: 'images/home_soil-compaction.png',
    action: {
      href: '/soil-compaction',
      label: $localize`Go to Soil compaction`,
    },
    ribbon: 'idea',
  },
  /*
  {
    title: $localize`Slurry optimization`,
    content:
      $localize`Optimize the route in the field and adjust application rate for slurry application to minimize unnecessary driving in the field.`,
    image: 'images/home_slurry.png',
    action: {
      href: '/slurry-optimization',
      label: $localize`Go to Slurry optimization`,
    },
    ribbon: 'idea',
  },
  */
  {
    title: $localize`Scheduling`,
    content: $localize`Easy creation of an efficient plan for your field operations.`,
    image: 'images/home_scheduling.png',
    action: {
      href: '/scheduling',
      label: $localize`Go to Scheduling`,
    },
    ribbon: 'idea',
  },
  /*
  {
    title: $localize`Wild Oats Mapping`,
    content: $localize`Detect wild oats during harvest - and use the data for targeted weed control.`,
    image: 'images/home_wild_oats_mapping.png',
    action: {
      href: '/wild-oats-mapping',
      label: $localize`Go to Wild oats mapping`,
    },
    ribbon: 'idea',
  },
  */
  {
    title: $localize`Guidance data converter`,
    content: $localize`Convert your guidance data. Easily upload your field boundaries, guidance lines, and obstacles, and convert them into the formats you need. We support most manufacturers, terminals, and farm management systems.`,
    image: 'images/home_data-converter.png',
    action: {
      label: $localize`Go to Guidance data converter`,
      href: '/guidance-data-converter',
    },
    ribbon: 'beta',
  },
];
